'use strict';
var userAgent = require('../internals/environment-user-agent');

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@twilio/declarative-type-validator/node_modules/core-js/internals/environment-is-ios.js
// module id = 2476
// module chunks = 25